function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "register-sucessful",
  transform: "translate(2.5 2.5)"
}, React.createElement("path", {
  id: "Path_3353",
  "data-name": "Path 3353",
  d: "M60.1,0a60.1,60.1,0,1,0,60.1,60.1A60.167,60.167,0,0,0,60.1,0Zm0,112.318A52.218,52.218,0,1,1,112.317,60.1,52.277,52.277,0,0,1,60.1,112.318Z",
  fill: "#403f50",
  stroke: "#fff",
  strokeWidth: 5
}), React.createElement("path", {
  id: "Path_3354",
  "data-name": "Path 3354",
  d: "M155.444,131.838l-30.991,30.989L111.925,150.3a3.941,3.941,0,0,0-5.573,5.575l15.314,15.312a3.943,3.943,0,0,0,5.574,0,.073.073,0,0,1,.008-.011l33.767-33.767a3.94,3.94,0,1,0-5.572-5.573Z",
  transform: "translate(-73.585 -91.413)",
  fill: "#00bf6f",
  stroke: "#fff",
  strokeWidth: 4
}));
var SvgRegisterSucessful = function SvgRegisterSucessful(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 125.2,
    height: 125.2,
    viewBox: "0 0 125.2 125.2",
    ref: svgRef
  }, props), _ref2);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRegisterSucessful, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/register-sucessful.2458a378.svg";
export { ForwardRef as ReactComponent };